import React, { useContext } from 'react';
import { Link, useLoaderData, useSearchParams, Outlet, redirect } from 'react-router-dom';
import { ContentFrame } from '../../components/content_frame/content_frame';
import { 
  DOCUMENT_LIST_PATH, 
  DOCUMENT_ADD_PATH, 
  DOCUMENT_EDIT_PATH, 
  DEFAULT_DELETE_PATH, 
  DESKTOP_PATH,
  LOGIN_PATH } from '../../constants/paths';
import { DOCUMENTS_GET_API } from '../../constants/apis';
import { AuthContext } from '../../contexts';
import ModelTable, { Property } from '../../components/model_table/model_table';
import DefaultSection from '../../components/default_section/default_section';
import { getModels } from '../../utils/functions';
import { MANAGE_DOCUMENT_PERMISSION } from '../../constants/permissions';
import './document_list.scss';


export async function documentListLoader() {  
  try {
    return await getModels(DOCUMENTS_GET_API);
  }
  catch(errors) {
    if(errors instanceof Array) {
      for(let error of errors) {
        if(error.code === 209) {
          // Expired user session
          return redirect(LOGIN_PATH);
        }
        else if(error.code === 203) {
          // Not authorized
          return redirect(DESKTOP_PATH);
        }
      }
    }

    throw errors;    
  }
};

class DocumentList extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      screenWidth: window.innerWidth
    };
  }

  async componentDidMount() {
    this.resizeListener = () => this.updateSize();

    window.addEventListener("resize", this.resizeListener);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.resizeListener);
  }

  updateSize() {
    this.setState({
      screenWidth: window.innerWidth
    });
  }

  listHasActions() {
    return this.props.auth.permission_ids.includes(MANAGE_DOCUMENT_PERMISSION);
  }

  getActions(entry) {
    return (
      <div className="model-table__model-actions-container">
      
        <Link
          className="model-table__default-edit-button"
          to={`${DOCUMENT_EDIT_PATH}${entry.id}`}
        >

            <i className="fas fa-edit"></i>

        </Link>
        
        <Link
          className="model-table__default-delete-button"
          to={`${DEFAULT_DELETE_PATH.slice(1)}${entry.id}`}
        >

            <i className="far fa-trash-alt"></i>

        </Link>

      </div>
    );
  }

  getProperties() {
    let properties = [
      Property('name', 'Nome', <i className="fa-solid fa-tag"></i>),
      Property('description', 'Descrição', <i className="fa-solid fa-circle-info"></i>)
    ];

    return properties;
  }

  render() {
    return (
      <>
        
        <Outlet />

        <ContentFrame
          headerHistory={[
            {
              path: DESKTOP_PATH,
              text: "Área de trabalho"
            },
            {
              path: DOCUMENT_LIST_PATH,
              text: "Listar documentos"
            },
          ]}
          titleIcon={<i className="fas fa-clipboard-list"></i>}
          title="Listar documentos"
        >

          <DefaultSection
            className="document-list"
            title="Lista de documentos"
          >

            <div className="document-list__list-actions">

              {this.props.auth.permission_ids.includes(MANAGE_DOCUMENT_PERMISSION) &&
                <Link
                  className="model-table__default-button"
                  to={DOCUMENT_ADD_PATH}
                >

                  <i className="fas fa-plus"></i> Adicionar documento

                </Link>
              }

            </div>

            <ModelTable
              properties={this.getProperties()}
              getActions={this.listHasActions() ? (entry) => this.getActions(entry) : null}
              data={this.props.documents}
              initialOrderBy="name"
            >

            </ModelTable>

          </DefaultSection>

        </ContentFrame>

      </>
    );
  }
};

const WrappedDocumentList = props => {
  const documents = useLoaderData();
  const auth = useContext(AuthContext);
  const [searchParams, setSearchParams] = useSearchParams();

  return (
    <DocumentList
      documents={documents}
      auth={auth}
      searchParams={searchParams}
      setSearchParams={setSearchParams}
      {...props}
    />
  );
};

export {WrappedDocumentList as DocumentList};
